import React from "react";
import UserPhoto from "./UserPhoto";
import UserFullName from "./UserFullName";
import LastMessage from "./LastMessage";
import UnreadCount from "./UnreadCount";
import ContextMenu from "./ContextMenu";
import DaysAgo from "./DaysAgo";
import { FaIcon } from "../../shared/ui";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import ContextMenuPortal from "./ContextMenuPortal";
import { isDesktop } from "react-device-detect";

function RecentChatUserListItem({
    user,
    activeUserId,
    onUserSelect,
    onEllipsisClick,
    menuState,
    handleDelete,
    handleScheduleAppointment,
    handleCloseMenu,
    onBlockUserClick,
}) {
    return (
        <li
            key={user.id}
            className={`user-item ${user.id === activeUserId ? "active" : ""}`}
            onClick={() => onUserSelect(user.id)}
        >
            <div className="flex spacing-3">
                <div className="user-avatar">
                    <UserPhoto
                        photo={user.photo}
                        firstName={user.firstName}
                        lastName={user.lastName}
                        sharedFirstName={user.sharedFirstName}
                        sharedLastName={user.sharedLastName}
                    />
                </div>
                <div>
                    <UserFullName
                        name={user.name}
                        firstName={user.firstName}
                        lastName={user.lastName}
                        sharedFirstName={user.sharedFirstName}
                        sharedLastName={user.sharedLastName}
                    />
                    <LastMessage text={user.lastMessageText} />
                </div>
            </div>

            <div className="flex-col">
                <div className="flex-end spacing-1">
                    <div
                      className={`ellipsis-icon${isDesktop ? " desktop-hover" : ""}`}
                      onClick={(e) => {
                          e.stopPropagation();
                          onEllipsisClick(e, user.id);
                      }}
                      onTouchStart={(e) => {
                          e.stopPropagation();
                          onEllipsisClick(e, user.id);
                      }}
                    >
                        <FaIcon icon={faEllipsisH} size="sm" />
                    </div>
                    <UnreadCount count={user.unreadCount} />

                    {menuState.open && menuState.userId === user.id && (
                      <ContextMenuPortal>
                          <ContextMenu
                            onDelete={(e) => {
                                e.stopPropagation();
                                handleDelete();
                            }}
                            onScheduleAppointment={(e) => {
                              e.stopPropagation();
                              handleScheduleAppointment();
                            }}
                            onBlockUser={(e) => {
                                e.stopPropagation();
                                if (onBlockUserClick) onBlockUserClick(user.id);
                                handleCloseMenu();
                            }}
                            onClose={handleCloseMenu}
                            position={menuState.position}
                          />
                      </ContextMenuPortal>
                    )}
                </div>
                <div className="days-ago">
                    <DaysAgo date={user.lastMessageDate} />
                </div>
            </div>
        </li>
    );
}

export default RecentChatUserListItem;